import { render, staticRenderFns } from "./ScoringCriterionFormWrapper.vue?vue&type=template&id=42c10d28"
import script from "./ScoringCriterionFormWrapper.vue?vue&type=script&lang=js"
export * from "./ScoringCriterionFormWrapper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports